import { DestroyRef, inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { EVENT_BUS } from '@shared/domain/tokens/event-bus.token';
import { ServiceStateService } from '@features/service/application/services/service-state.service';
import {ServiceRemovedDeviceEvent} from '@platform/event-bus/domain/events/service-removed-device.event';


@Injectable({ providedIn: 'root' })
export class ServiceDeviceSubscriber {
  private readonly eventBus = inject(EVENT_BUS);
  private readonly destroyRef = inject(DestroyRef);
  private readonly serviceStateService = inject(ServiceStateService);

  constructor() {
    this.eventBus.ofType(ServiceRemovedDeviceEvent).pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(() => {
      this.serviceStateService.clearSelection();
    });

  }
}